module.exports = __webpack_public_path__ + "static/img/icon9.9f2a18f9.svg";